import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BidderModel } from '../models/bidder';
import { Observable } from 'rxjs';
import { VerificationModel } from '../models/verification';
import { environment } from 'src/environments/environment.local';

@Injectable({ providedIn: 'root' })
export class LookupService {

    constructor(private http: HttpClient) { }

    getStates() {
        return this.http.get<any>(`${environment.BASE_API_URL}common/GetStates`);
    }

    getVehicleTypes() {
        return this.http.get<any>(`${environment.BASE_API_URL}common/GetVehicleType`);
    }

    getIdentity() {
        return this.http.get<any>(`${environment.BASE_API_URL}bidder/getidentity`);
    }

    getBidderType() {
        return this.http.get<any>(`${environment.BASE_API_URL}bidder/getbiddertype`);
    }

    getBidderbyid(UserId: any,EnterpriseId: number) {
        return this.http.get<any>(`${environment.BASE_API_URL}bidder/getBidderById?UserId=${UserId}&EnterpriseId=${EnterpriseId}`);
    }

    GetBidderInfoByBidderNo(BidderNo: any,EnterpriseId: number) {
        return this.http.get<any>(`${environment.BASE_API_URL}bidder/GetBidderInfoByBidderNo?BidderNo=${BidderNo}&EnterpriseId=${EnterpriseId}`);
    }
    
    getBidderNames() {
        return this.http.get<any>(`${environment.BASE_API_URL}bidder/GetBidderNames`);
    }
    getMakes() {
        return this.http.get<any>(`${environment.BASE_API_URL}common/GetMakes`);
    }

    getModels(MakeId: number) {
        return this.http.get<any>(`${environment.BASE_API_URL}common/GetModels?MakeId=` + MakeId);
    }

    getColors() {
        return this.http.get<any>(`${environment.BASE_API_URL}common/GetColors`);
    }

    getYears() {
        return this.http.get<any>(`${environment.BASE_API_URL}common/GetYears`);
    }

    getMasterDataForAuction(enterpriseId: number) {
        return this.http.get<any>(`${environment.BASE_API_URL}Common/GetMasterDataForAuction?EnterpriseId=${enterpriseId}`);
    }

    getStyles() {
        return this.http.get<any>(`${environment.BASE_API_URL}common/GetStyles`);
    }

    getEnterprise(Id = 0) {
        return this.http.get<any>(`${environment.BASE_API_URL}common/GetEnterprise?Id=${Id}`);
    }
    
    getCurrentAuctionDates(enterpriseId: number) {
        return this.http.get<any>(`${environment.BASE_API_URL}enterprise/SelectCurrentAuctionDates?enterpriseId=${enterpriseId}`);
    }

    getPastAuctionDate(enterpriseId: number) {
        return this.http.get<any>(`${environment.BASE_API_URL}enterprise/SelectPastAuctionDate?enterpriseId=${enterpriseId}`);
    }

    getAllAuctionDates(pageNum: number, pageSize: number, enterpriseId: number,storageLotId:number) {
        return this.http.get<any>(`${environment.BASE_API_URL}enterprise/GetAllAuctionDates?pageNum=${pageNum}&pageSize=${pageSize}&enterpriseId=${enterpriseId}&storageLotId=` +storageLotId);
    }

    getFutureAuctionDates(enterpriseId: number) {
        return this.http.get<any>(`${environment.BASE_API_URL}enterprise/GetFutureAuctionDates?enterpriseId=${enterpriseId}`);
    }

    public getIPAddress() {
        return this.http.get("http://api.ipify.org/?format=json");
    }

    saveSellerConfigTools(enterpriseId: number, isAutoIncreament, amount, settingType) {
        return this.http.get<any>(`${environment.BASE_API_URL}enterprise/SaveSellerConfigTools?enterpriseId=${enterpriseId}&isAutoIncreament=${isAutoIncreament}&amount=${amount}&settingType=${settingType}`);
    }
    getAuctionDateDetails(auctionDateId): Observable<any> {
        return this.http.get(`${environment.BASE_API_URL}enterprise/GetAuctionDateDetails?auctionDateId=${auctionDateId}`);
    }

    getProductStatus(): Observable<any> {
        return this.http.get(`${environment.BASE_API_URL}enterprise/GetProductStatus`);
    }

    saveNotification(model) {
        return this.http.post(`${environment.BASE_API_URL}bidder/SaveNotification`, model);
    }

    sendOtp(model) {
        return this.http.post(`${environment.BASE_API_URL}bidder/SendOTP`, model);
    }

    verifyOTP(bidderId: any, OneTimePassword: any, Type,NotifyEmail,NotifyPhone) {
        return this.http.post(`${environment.BASE_API_URL}bidder/VerifyOTP`, { BidderId: bidderId, OTP: OneTimePassword, Type: Type,NotifyEmail:NotifyEmail,NotifyPhone:NotifyPhone });
    }

    SendSignUpOTP(model) {
        return this.http.post(`${environment.BASE_API_URL}bidder/SendSignUpOTP`, model);
    }

    VerifySignUpOTP(OneTimePassword: any,NotifyPhone) {
        return this.http.post(`${environment.BASE_API_URL}bidder/VerifySignUpOTP`, { OTP: OneTimePassword,NotifyPhone:NotifyPhone });
    }

    getNotificationDetailsbyid(bidderid: any) {
        return this.http.get(`${environment.BASE_API_URL}bidder/GetNotificationDetails?bidderid=${bidderid}`);
    }
    CheckVerifiedEmailOrPhone(bidderId: any, email: any, phone:any, type: any) {
        return this.http.post(`${environment.BASE_API_URL}bidder/CheckVerifiedEmailOrPhone`, { BidderId: bidderId, NotifyEmail: email, NotifyPhone:phone, Type: type });
    }

    getEvents() {
        return this.http.get(`${environment.BASE_API_URL}bidder/GetEventList`);
    }

    getCustomSetting(KeyName) {
        return this.http.get<any>(`${environment.BASE_API_URL}common/GetCustomSetting?KeyName=${KeyName}`);
    }
    getNextAuctionDates(enterpriseId: number) {
        return this.http.get<any>(`${environment.BASE_API_URL}enterprise/GetNextAuctionDates?enterpriseId=${enterpriseId}`);
    }

    getVerification(token) {
        return this.http.get<any>(`${environment.BASE_API_URL}bidder/Verification?token=${token}`);
    }
    getBiddersByAuctionDate(auctionDateId: any) {
        return this.http.get<any>(`${environment.BASE_API_URL}bidder/GetBiddersByAuctionDate?auctionDateId=` + auctionDateId);
    }
    DeleteAuctionDate(model) {
        return this.http.post(`${environment.BASE_API_URL}enterprise/DeleteAuctionDate`, model);
    }
    GetAuctionSummary() {
        return this.http.get<any>(`${environment.BASE_API_URL}enterprise/GetAuctionSummary`);
    }
    getEnterpriseStorageLots(enterpriseId: number,userName: string) {
        return this.http.get<any>(`${environment.BASE_API_URL}enterprise/GetEnterpriseStorageLots?enterpriseId=${enterpriseId}&userName=${userName}`);
    }
    getAuctionRemoveReason() {
        return this.http.get<any>(`${environment.BASE_API_URL}common/GetAuctionRemoveReason`);
    }
    getVinReviewStatus() {
        return this.http.get<any>(`${environment.BASE_API_URL}common/GetVinReviewStatus`);
    }
    getLatestAuctionDates(enterpriseId: number,storageLotId: number) {
        return this.http.get<any>(`${environment.BASE_API_URL}enterprise/GetLatestAuctionDates?enterpriseId=${enterpriseId}&storageLotId=${storageLotId}`);
    }
    getEndedAuctionDates(enterpriseId: number,storageLotId: number) {
        return this.http.get<any>(`${environment.BASE_API_URL}enterprise/GetEndedAuctionDates?enterpriseId=${enterpriseId}&storageLotId=${storageLotId}`);
    }
    getEndedAuctionDatesByBidder(enterpriseId: number, bidderId: number, storageLotId: number) {
        return this.http.get<any>(`${environment.BASE_API_URL}enterprise/getEndedAuctionDatesByBidder?enterpriseId=${enterpriseId}&bidderId=${bidderId}&storageLotId=${storageLotId}`);
    }
    selectCurrentAuction(enterpriseId,storageLotGuid) {
        return this.http.get<any>(`${environment.BASE_API_URL}enterprise/SelectCurrentAuction?EnterpriseId=${enterpriseId}&StorageLotGuidID=${storageLotGuid}`);
    }
    selectUpcomingAuction(enterpriseId,storageLotGuid) {
        return this.http.get<any>(`${environment.BASE_API_URL}enterprise/SelectUpcomingAuctionWithModel?EnterpriseId=${enterpriseId}&StorageLotGuidID=${storageLotGuid}`);
    }

    checkViewCount(productId, enterpriseId,storageLotId, adateId, isCurrent,isUpcoming, typeList) {
        return this.http.get<any>(`${environment.BASE_API_URL}api/AuctionWeb/CheckViewCount?productId=${productId}&enterpriseId=${enterpriseId}&storageLotId=${storageLotId}&adateId=${adateId}&isCurrent=${isCurrent}&isUpcoming=${isUpcoming}&typeList=${typeList}`);
    }

    addViewCounter(productId, enterpriseId,storageLotId, adateId, isCurrent,isUpcoming, typeList) {
        console.log({ ProductId: productId, EnterpriseId: enterpriseId, StorageLotId:storageLotId, AdateId: adateId,  IsCurrent: isCurrent, IsUpcoming: isUpcoming, typeList: typeList});
        return this.http.post<any>(`${environment.BASE_API_URL}api/AuctionWeb/AddViewCounter`, { ProductId: productId, EnterpriseId: enterpriseId, StorageLotId:storageLotId, AdateId: adateId,  IsCurrent: isCurrent, IsUpcoming: isUpcoming, typeList: typeList});
    }

    getBidRequestStatus() {
        return this.http.get<any>(`${environment.BASE_API_URL}bidder/GetBidRequestStatus`);
    }

    getIdsFromGUIDs(storageLotWTGUID, auctionDateGUID, GTAEnterpriseGUID) {
        return this.http.post<any>(`${environment.BASE_API_URL}Common/getIdsFromGUIDs`, { StorageLotWTGUID: storageLotWTGUID, AuctionDateGUID: auctionDateGUID, GTAEnterpriseGUID: GTAEnterpriseGUID });
    }
}  